module.exports = __webpack_public_path__ + "static/media/coin-gotten.c286d57b.ogg";